import { createContext } from "react";

export const catagoryContext = createContext({});
export const cartContext = createContext({});
export const alertContext = createContext({});